export default "__VITE_ASSET__mJK_5UvU__"